var m = require('mithril');
var layout = require('../layout/layout');
var settings = require('./settings');

module.exports = {
  '/settings': {
    view: function () {
      return m(layout, m(settings));
    }
  }
};
